import React from 'react'
import { CircularProgress } from '@mui/material'

export const Loading = () => {
  return (
    <div className='flex items-center gap-4 m-auto p-2'
    >
      <CircularProgress />
      <span className='backdrop-blur-sm'>Cargando...</span>
    </div>
  )
}
